export default __webpack_public_path__ + "static/media/tl-hands.8d41f347.png";